import { api } from './client';
import type { KingdomDiplomacyResponse } from '../types/diplomacy';
import type { DeclareWarResult, MutualPeaceResult, WithdrawResult, CancelCeasefireResult } from '../types/warActions';

export async function getKingdomDiplomacy(
  worldId: string,
  kingdomId: string
): Promise<KingdomDiplomacyResponse> {
  const response = await api.get<KingdomDiplomacyResponse>(
    `/api/worlds/${worldId}/kingdoms/${kingdomId}/diplomacy`
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to fetch diplomacy data');
  }
  return response.data;
}

export async function declareWar(
  worldId: string,
  provinceId: string,
  targetKingdomId: string
): Promise<DeclareWarResult> {
  const response = await api.post<DeclareWarResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/war/declare`,
    { targetKingdomId }
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to declare war');
  }
  return response.data;
}

export async function proposePeace(
  worldId: string,
  provinceId: string
): Promise<MutualPeaceResult> {
  const response = await api.post<MutualPeaceResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/war/peace`
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to propose peace');
  }
  return response.data;
}

export async function withdraw(
  worldId: string,
  provinceId: string
): Promise<WithdrawResult> {
  const response = await api.post<WithdrawResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/war/withdraw`
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to withdraw from war');
  }
  return response.data;
}

export async function cancelCeasefire(
  worldId: string,
  provinceId: string
): Promise<CancelCeasefireResult> {
  const response = await api.post<CancelCeasefireResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/war/ceasefire/cancel`
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to cancel ceasefire');
  }
  return response.data;
}
